import React, { useState } from "react";
import { Chrome, Download, Puzzle, FolderOpen, RefreshCw } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/context/I18nContext";

const DOWNLOAD_URL = `${process.env.REACT_APP_BACKEND_URL}/api/extension/download`;

export function ExtensionDialog({ trigger }) {
  const { lang } = useI18n();
  const [open, setOpen] = useState(false);
  const ar = lang === "ar";

  const steps = ar
    ? [
        { icon: Download, t: "حمّل ملف الإضافة (ZIP) ثم فك الضغط." },
        { icon: Puzzle, t: "افتح chrome://extensions أو edge://extensions وفعّل وضع المطور (Developer mode)." },
        { icon: FolderOpen, t: "اضغط Load unpacked واختر المجلد الذي فككت ضغطه." },
        { icon: RefreshCw, t: "افتح web.whatsapp.com، سجّل الدخول في الإضافة، وحدّث الصفحة." },
      ]
    : [
        { icon: Download, t: "Download the extension (ZIP) and unzip it." },
        { icon: Puzzle, t: "Open chrome://extensions or edge://extensions and turn on Developer mode." },
        { icon: FolderOpen, t: "Click 'Load unpacked' and select the unzipped folder." },
        { icon: RefreshCw, t: "Open web.whatsapp.com, sign in via the extension popup, and refresh the page." },
      ];

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-head text-xl text-primary">
            <Chrome size={22} /> {ar ? "إضافة المتصفح لواتساب ويب" : "WhatsApp Web Extension"}
          </DialogTitle>
          <DialogDescription>
            {ar
              ? "ترجمة الرسائل النصية والصوتية مباشرة داخل واتساب ويب — يعمل على Chrome و Edge."
              : "Translate text & voice notes right inside WhatsApp Web — works on Chrome & Edge."}
          </DialogDescription>
        </DialogHeader>

        <a href={DOWNLOAD_URL} download data-testid="download-extension-link">
          <Button className="w-full h-12 rounded-xl bg-accent hover:bg-accent/90 text-base" data-testid="download-extension-btn">
            <Download size={18} /> {ar ? "تحميل الإضافة" : "Download Extension"}
          </Button>
        </a>

        <ol className="space-y-3 mt-2">
          {steps.map((s, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="h-8 w-8 shrink-0 rounded-lg bg-secondary text-primary grid place-items-center">
                <s.icon size={16} />
              </span>
              <span className="text-sm text-foreground/90 leading-relaxed pt-1.5">
                <b className="text-primary">{i + 1}.</b> {s.t}
              </span>
            </li>
          ))}
        </ol>

        <p className="text-xs text-muted-foreground mt-1">
          {ar
            ? "ملاحظة: يدعم Chrome و Microsoft Edge (الإصدارات الحديثة)."
            : "Note: Supports Chrome and Microsoft Edge (recent versions)."}
        </p>
      </DialogContent>
    </Dialog>
  );
}
